const diagnosisMaxilloSurgeryList = [
  {
    name: "Періодонтит(постійний)",
    code: "K04.4",
    codeIcpc: "D82",
    codeAkmi: "97311-0X",
    opName: "(х - це к-сть зубів)",
  },
  {
    name: "Періодонтит(тимчасовий)",
    code: "K04.4",
    codeIcpc: "D82",
    codeAkmi: "97322-0X",
    opName: "Видалення(х - це к-сть зубів)",
  },
  {
    name: "Періостит",
    code: "K10.2",
    codeIcpc: "D82",
    codeAkmi: "30223-03",
    opName: "Розкриття та дренування",
  },
  {
    name: "Підщелепний абсцес",
    code: "K12.2",
    codeIcpc: "D83",
    codeAkmi: "30223-03",
    opName: "Розкриття та дренування",
  },
  {
    name: "Абсцес шкіри",
    code: "L02.0",
    codeIcpc: "S10",
    codeAkmi: "30223-01",
    opName: "Розкриття та дренування",
  },
  {
    name: "Вивих зуба(видалення)",
    code: "S03.2",
    codeIcpc: "D80",
    codeAkmi: "97322-0X",
    opName: "Видалення(х - це к-сть зубів)",
  },
  {
    name: "Вивих зуба(реплантація)",
    code: "S03.2",
    codeIcpc: "D80",
    codeAkmi: "97387-00",
    codeAkmiAdd: "97386-01",
  },
  {
    name: "Фурункул",
    code: "L02.0",
    codeIcpc: "S10",
    codeAkmi: "30223-01",
    opName: "Розкриття та дренування",
  },
  {
    name: "Гострий лімфаденіт",
    code: "L04.0",
    codeIcpc: "B70",
    codeAkmi: "",
    opName: "",
  },
  {
    name: "Стоматит",
    code: "K12.1",
    codeIcpc: "D83",
    codeAkmi: "",
    opName: "",
  },
  {
    name: "Сіалоаденіт",
    code: "K11.2",
    codeIcpc: "D83",
    codeAkmi: "",
    opName: "",
  },
  {
    name: "Рана брови",
    code: "S01.1",
    codeIcpc: "S18",
    codeAkmi: "90686-01",
    opName: "ПХО",
  },
  {
    name: "Рана повіки",
    code: "S01.1",
    codeIcpc: "S18",
    codeAkmi: "90686-01",
    opName: "ПХО",
  },
  {
    name: "Рана підочної ділянки",
    code: "S01.42",
    codeIcpc: "S18",
    codeAkmi: "90665-00",
    opName: "ПХО",
  },
  {
    name: "Рана губи",
    code: "S01.51",
    codeIcpc: "D80",
    codeAkmi: "90665-00",
    opAddName: "ПХО рани з висіченням",
    opName: "ПХО рани без висічення",
  },
  {
    name: "Рана щоки(шкіра)",
    code: "S01.41",
    codeIcpc: "S18",
    codeAkmi: "90665-00",
    opAddName: "ПХО рани з висіченням",
  },
  {
    name: "Рана язика",
    code: "S01.52",
    codeIcpc: "S18",
    codeAkmi: "90665-00",
    opAddName: "ПХО рани з висіченням",
  },
  {
    name: "Рана іншої ділянки",
    code: "S01.49",
    codeIcpc: "S18",
    codeAkmi: "90665-00",
    opAddName: "ПХО рани з висіченням",
  },
  {
    name: "Множинні рани рота",
    code: "S01.59",
    codeIcpc: "S18",
    codeAkmi: "90665-00",
    opName: "ПХО рани з висіченням",
  },
  {
    name: "Множинні рани шкіри",
    code: "S01.49",
    codeIcpc: "S18",
    codeAkmi: "90665-00",
    opName: "ПХО рани з висіченням",
  },
  {
    name: "Рана щоки(слизова)",
    code: "S01.52",
    codeIcpc: "D80",
    codeAkmi: "90665-00",
    opName: "ПХО рани з висіченням",
  },
  {
    name: "Рана підборіддя",
    code: "S01.88",
    codeIcpc: "S18",
    codeAkmi: "90665-00",
    opName: "ПХО рани з висіченням",
  },
  {
    name: "Рана лоба",
    code: "S01.88",
    codeIcpc: "S18",
    codeAkmi: "90665-00",
    opName: "ПХО рани з висіченням",
  },
  {
    name: "Рана піднебіння",
    code: "S01.55",
    codeIcpc: "S18",
    codeAkmi: "90665-00",
    opName: "ПХО рани з висіченням",
  },
  {
    name: "Забій чи садна обличчя",
    code: "S00.8",
    codeIcpc: "S16",
    codeAkmi: "",
    opName: "",
  },
  {
    name: "П-м н/щ(гілки)",
    code: "S02.64",
    codeIcpc: "L76",
    codeAkmi: "47777-00",
    codeAkmiAdd: "47756-00",
    opName: "Репозиція",
    opAddName: "Шинування",
  },
  {
    name: "П-м н/щ(кута)",
    code: "S02.65",
    codeIcpc: "L76",
    codeAkmi: "47777-00",
    codeAkmiAdd: "47756-00",
    opName: "Репозиція",
    opAddName: "Шинування",
  },
  {
    name: "П-м н/щ(суглобового)",
    code: "S02.61",
    codeIcpc: "L76",
    codeAkmi: "47777-00",
    codeAkmiAdd: "47756-00",
    opName: "Репозиція",
    opAddName: "Шинування",
  },
  {
    name: "П-м н/щ(тіла)",
    code: "S02.68",
    codeIcpc: "L76",
    codeAkmi: "47777-00",
    codeAkmiAdd: "47756-00",
    opName: "Репозиція",
    opAddName: "Шинування",
  },
  {
    name: "П-м н/щ(множинний)",
    code: "S02.69",
    codeIcpc: "L76",
    codeAkmi: "47777-00",
    codeAkmiAdd: "47756-00",
    opName: "Репозиція",
    opAddName: "Шинування",
  },
  {
    name: "П-м в/щ",
    code: "S02.4",
    codeIcpc: "L76",
    codeAkmi: "47777-00",
    codeAkmiAdd: "47756-00",
    opName: "Репозиція",
    opAddName: "Шинування",
  },
  {
    name: "П-м вилично-орбітального комплексу",
    code: "S02.4",
    codeIcpc: "L76",
    codeAkmi: "47762-00",
    opName: "Відкрита репозиція (МОС)",
  },
  {
    name: "Множинні п-ми кісток черепа",
    code: "S02.7",
    codeIcpc: "L76",
    codeAkmi: "47777-00",
    codeAkmiAdd: "47756-00",
    opName: "Репозиція",
    opAddName: "Шинування",
  },
  {
    name: "Вивих щелепи",
    code: "S03.0",
    codeIcpc: "L76",
    codeAkmi: "",
    opName: "",
  },
  {
    name: "Атерома",
    code: "L72.1",
    codeIcpc: "S93",
    codeAkmi: "31350-00",
    opName: "Ексцизійна біопсія",
  },
  {
    name: "Епуліс",
    code: "K06.8",
    codeIcpc: "D82",
    codeAkmi: "30023-00",
    opName: "Видалення",
  },
  {
    name: "Радикулярна кіста",
    code: "K04.8",
    codeIcpc: "D82",
    codeAkmi: "30283-00",
    opName: "Цистектомія",
  },
  {
    name: "Фолікулярна кіста",
    code: "K09.0",
    codeIcpc: "D82",
    codeAkmi: "30283-00",
    opName: "Цистектомія",
  },
  {
    name: "Ретенційна кіста",
    code: "D10.3",
    codeIcpc: "D83",
    codeAkmi: "30275-00",
    opName: "Видалення",
  },
  {
    name: "Надкомплектні зуби",
    code: "K00.1",
    codeIcpc: "D82",
    codeAkmi: "97323-0Х",
    opName: "Видалення(х - це к-сть зубів)",
  },
  {
    name: "Ретеновані зуби",
    code: "K01.0",
    codeIcpc: "D82",
    codeAkmi: "97323-0Х",
    opName: "Видалення(х - це к-сть зубів)",
  },
  {
    name: "Коротка вуздечка язика",
    code: "Q38.1",
    codeIcpc: "D81",
    codeAkmi: "30278-02",
    opName: "Френулотомія",
  },
  {
    name: "Серединна кіста шиї",
    code: "Q89.23",
    codeIcpc: "D81",
    codeAkmi: "30313-00",
    opName: "Видалення кісти",
  },
  {
    name: "Постекстракційна кровотеча",
    code: "T81.0",
    codeIcpc: "A80",
    codeAkmi: "97399-00",
    opName: "Зупинка кровотечі",
  },
  {
    name: "Мігруюча гранульома",
    codeIcpc: "S99",
    code: "D10.3",
    codeAkmi: "30275-00",
    opName: "Ексцизійна біопсія",
  },
  {
    name: "Гемангіома",
    codeIcpc: "S81",
    code: "D18.0",
    codeAkmi: "30075-01",
    opName: "Ексцизійна біопсія",
  },
  {
    name: "Новоутвір н/щ",
    codeIcpc: "L97",
    code: "D10.1",
    codeAkmi: "30275-00",
    opName: "Видалення новоутвору",
  },
  {
    name: "Новоутвір підяз. ділянки",
    codeIcpc: "D78",
    code: "D10.3",
    codeAkmi: "30275-00",
    opName: "Ексцизійна біопсія",
  },
  {
    name: "Дермоїдна кіста",
    codeIcpc: "D82",
    code: "K09.8",
    codeAkmi: "30075-01",
    opName: "Ексцизійна біопсія",
  },
];
const diagnosisOtolaryngologyList = [
  {
    name: "Закритий перелом кісток носа",
    codeIcpc: "L76",
    code: "S02.2",
    codeAkmi: "47738-00",
    codeAkmiAdd: "57921-00",
    opName: "Закрита репозиція",
    opAddName: "Rg носа",
  },
  {
    name: "Аденоїди",
    codeIcpc: "R90",
    code: "J35.2",
    codeAkmi: "41801-00",
    opName: "Аденотомія",
  },
  {
    name: "Аденоїди+мигдалики",
    codeIcpc: "R90",
    code: "J35.3",
    codeAkmi: "41789-01",
    opName: "Тонзиладенотомія",
  },
  {
    name: "Фурункул присінку носа",
    codeIcpc: "R73",
    code: "J34.0",
    codeAkmi: "30223-01",
    opName: "Розкриття та дренування",
  },
  {
    name: "Хронічний декомпенс. тонзиліт",
    codeIcpc: "R90",
    code: "J35.0",
    codeAkmi: "41798-00",
    opName: "Двобічна тонзилектомія",
  },
  {
    name: "Паратонзилярний абсцес",
    codeIcpc: "R76",
    code: "J36.0",
    codeAkmi: "41807-00",
    opName: "Розкриття абсцесу",
  },
  {
    name: "Травм. перф. барабанної перетинки",
    codeIcpc: "H77",
    code: "H72.0",
    codeAkmi: "41530-00",
    opName: "Тимпанопластика",
  },
  {
    name: "Викривлення переділки носа",
    codeIcpc: "R99",
    code: "J34.2",
    codeAkmi: "41671-00",
    opName: "Підслизова резекція переділки носа",
  },
  {
    name: "Гострий гнійний середній отит",
    codeIcpc: "H71",
    code: "H66.0",
    codeAkmi: "41626-01",
    opName: "Парацентез барабанної перетинки",
  },
  {
    name: "Антрохоанальний поліп",
    codeIcpc: "R99",
    code: "J33.8",
    codeAkmi: "41716-03",
    opName: "Видалення поліпа",
  },
  {
    name: "Відкритий перелом носа",
    codeIcpc: "L76",
    code: "S02.2",
    codeAkmi: "47741-00",
    codeAkmiAdd: "57921-00",
    opName: "Відкрита репозиція",
    opAddName: "Rg носа",
  },
  {
    name: "Сенсоневральна приглухуватість",
    codeIcpc: "H02",
    code: "H93.3",
    codeAkmi: "11309-00",
    opName: "Аудіометрія",
  },
  {
    name: "Атрезія слухового проходу",
    codeIcpc: "H80",
    code: "Q16.1",
    codeAkmi: "45662-00",
    opName: "пластика слухового проходу",
  },
  {
    name: "Хронічний середній отит",
    codeIcpc: "H66.1",
    code: "H74",
    codeAkmi: "41638-01",
    opName: "",
    opAddName: "Тимпанопластика",
  },
  {
    name: "Пансинусит",
    codeIcpc: "R75",
    code: "J01.4",
    codeAkmi: "41701-00",
    opName: "Пункція гайморової пазухи",
  },
  {
    name: "Гострий мастоїдит",
    codeIcpc: "H71",
    code: "H70.0",
    codeAkmi: "41632-00",
    codeAkmiAdd: "41626-00",
    opName: "Шунтування",
    opAddName: "Однобічний парацентез",
  },
  {
    name: "Доброякісний утвір вушної раковини",
    codeIcpc: "H75",
    code: "D23.2",
    codeAkmi: "30075-01",
    opName: "Ексцизійна біопсія",
  },
  {
    name: "Садно носа",
    code: "S00.31",
    codeIcpc: "R88",
    codeAkmi: "A67041",
    opName: "Консультація ЛОРа",
  },
  {
    name: "Забій носа",
    code: "S00.35",
    codeIcpc: "R88",
    codeAkmi: "A67041",
    opName: "Консультація ЛОРа",
  },
  // template
  {
    name: "Стороннє тіло вуха",
    code: "T16.0",
    codeIcpc: "H76",
    codeAkmi: "41500-00",
    opName: "Видалення стороннього тіла(без розрізу)",
  },
  {
    name: "Стороннє тіло носа",
    code: "T17.1",
    codeIcpc: "R87",
    codeAkmi: "41659-00",
    opName: "Видалення стороннього тіла",
  },
  {
    name: "Гемісинусит",
    codeIcpc: "R75",
    code: "J01.0",
    codeAkmi: "41743-00",
    opName: "Фронтотомія",
  },

  // { name: "", codeIcpc: "", code: "", codeAkmi: "", opName: "", opAddName: "" }
];
const diagnosisFree = [
  { name: "Діагноз", code: "", codeIcpc: "", codeAkmi: "" },
];
export const maxilloSortedList = diagnosisFree.concat(
  diagnosisMaxilloSurgeryList.sort(function (a, b) {
    return a.name.localeCompare(b.name);
  }),
);
export const otoSortedList = diagnosisFree.concat(
  diagnosisOtolaryngologyList.sort(function (a, b) {
    return a.name.localeCompare(b.name);
  }),
);
